import api from "../axios";
import Api from "../Api";

/// reymar update 

export async function ProcessInvoice(auction_id) {
 
  const response = await api
    .post(`${Api.request.URL}/invoices/process/${auction_id}`,[])
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}


export async function createCheckout(auction_id,checkout_id) {
 
  const response = await api
    .post(`${Api.request.URL}/invoices/create-checkout-session/`,[auction_id,checkout_id])
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}



export async function SendEmail(auction_id) {
 
  const response = await api
    .post(`${Api.request.URL}/invoices/send-all/${auction_id}`,[])
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}


/// end reymar



export async function AuctionCreate(ArrayData) {
  const response = await api
    .post(`${Api.request.URL}/auction`, ArrayData)
    .then((res) => {
      //  console.log("data data: ", res.data);
      return res.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return response;
}

export async function InvoiceDetails() {
  const response = await api
  .get(`${Api.request.URL}/setting?id=invoice_details`)
  .then((res) => {

    let row = {};
    res.data.data.map((val) => {
      return (row = val);
    });
    return row;
  })
  .catch((error) => {
    return error.response.data.msg;
  });
return response;

}

export async function GetAuctionByID(id) {
  const response = await api
    .get(`${Api.request.URL}/auction/${id}`)
    .then((res) => {

      let row = {};
      res.data.data.map((val) => {
        return (row = val);
      });
      return row;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}





export async function ListWinnerGet(eventID) {
  const response = await api
    .get(`${Api.request.URL}/report/winner?auction_id=${eventID}`)
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.sucess;
    });
  return response;
}




export async function GetAuctionSetByID(id) {
  const response = await api
    .get(`${Api.request.URL}/auction_set?auction_id=${id}`)
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}


export async function AuctionUpdateSend(id, ArrayData) {

  const response = await api
    .put(`${Api.request.URL}/auction/${id}`, ArrayData)
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}


export async function AuctionSetupUpdate(id, ArrayData) {
  const response = await api
    .put(`${Api.request.URL}/auction_set/${id}`, ArrayData)
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}


export async function AuctionSetupCreate(ArrayData) {
  const response = await api
    .post(`${Api.request.URL}/auction_set`, ArrayData)
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}

export async function AuctionList(search,start) {

  const response = await api
    .get(
      `${Api.request.URL}/auction?s=${
        search === undefined ? "" : search
      }&start=${start === undefined ? 0 : start}&limit=10`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}

export async function getApprove(id) {
  try {
    const res = await api.put(`${Api.request.URL}/users/approve-joiner/${id}`);
    // Fix the typo here
    return {
      success: res.data.sucess, // note the typo 'sucess' from API
      message: res.data.msg || "",
      ...res.data, // in case you want the full response
    };
  } catch (error) {
    console.error("Approval error:", error?.response?.data || error.message);

    return {
      success: false,
      message: error?.response?.data?.msg || "An error occurred.",
    };
  }
}

export async function getDecline(id) {
  try {
    const res = await api.put(`${Api.request.URL}/users/decline-joiner/${id}`);
    // Fix the typo here
    return {
      success: res.data.sucess, // note the typo 'sucess' from API
      message: res.data.msg || "",
      ...res.data, // in case you want the full response
    };
  } catch (error) {
    console.error("Approval error:", error?.response?.data || error.message);

    return {
      success: false,
      message: error?.response?.data?.msg || "An error occurred.",
    };
  }
}


//// pag approval request    kk llfdd rrtewqwjj kkkjkjnhh    das  test result test result test result dklasn dln


export async function requestForApproval(auctionID) {

  const response = await api
    .get(
      `${Api.request.URL}/users/joiner/${auctionID}`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}




export async function selectsetting() {

  const response = await api
    .get(
      `${Api.request.URL}/setting`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}



export async function getIDset(auctionID) {
        
  const response = await api
    .get(
      `${Api.request.URL}/auction_set?auction_id=${auctionID}` 
    )
    .then((res) => {
    console.log(' res.data: ', res.data)
      return res.data.data;
    }) 
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message) mm     mllkytyfuyruyruyruyrtyruyr nn  nn nn nn nn m
       
      return error.response.data.sucess;
    });
  return response;
}

export async function getArtist(search) {
  try {
    const response = await api.get(
      `${Api.request.URL}/lot/getArtist?search=${search === undefined ? "" : search}`
    );
    // Siguraduhin na ang ibinabalik ay ang mismong data mula sa API
    return response.data; 
  } catch (error) {
    console.error('Error fetching artist:', error);
    // Sa halip na boolean lang, ibalik ang format na inaasahan ng component
    // para hindi ito mag-crash
    return { 
      success: false, 
      msg: "no record found", 
      data: [] 
    };
  }
}


export async function postPrivate(lot_id,artist_id) {

   const data = {
      'id': lot_id,
     'artist_id':artist_id
   }
  const response = await api
    .post(
      `${Api.request.URL}/lot/privateSale`,data
    )
    .then((res) => {
   
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}



export async function ReleaseSave(formData) {
  try {
    const res = await api.post(`${Api.request.URL}/report/release-save`, formData);
 
    return res.data;  // return actual response data
  } catch (error) { 
    console.error('ReleaseSave error:', error);
    // Return an error object or throw to be handled in caller
    // You can customize this based on your API error response shape
    return { success: false, error: error.response?.data?.msg || error.message };
  }
}

export async function ReleaseCancel(id) {
  try {
    const res = await api.put(`${Api.request.URL}/report//releasing/${id}/cancel`);
    return res.data.msg;
  } catch (error) {
    return {
      sucess: false,
      error: error.response?.data?.message || "Cancel request failed"
    };
  }
}


export async function GenerateReceipt() {
  try {
    const res = await api.get(`${Api.request.URL}/report/generate-no`);
    console.log("generate number",res)
    // Destructure the needed values
    const { msg, number } = res.data;

    return {
      success: true,
      message: msg,
      number: number
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || "Cancel request failed"
    };
  }
}



// export async function GenerateReceipt() {

//   try {
//     const res = await api.get(`${Api.request.URL}/report/generate-no`);
//     return res.data.msg;
//   } catch (error) {
//     return {
//       sucess: false,
//       error: error.response?.data?.message || "Cancel request failed"
//     };
//   }

// }



// export async function ReleaseCancel(ArrayData) {

//   const response = await api
//     .put(`${Api.request.URL}/report//releasing/1/cancel`, ArrayData)
//     .then((res) => {
//       return res.data.msg;
//     })
//     .catch((error) => {
//       return error.response.data.msg;
//     });
//   return response;
// }



export async function findAuctionLot(id,lot) {

  const response = await api
    .get(
      `${Api.request.URL}/report/find?auction_id=${id}&lot_number=${lot}`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}


export async function Releasing(page,limit,search) {

  const response = await api
    .get(
      `${Api.request.URL}/report/releasing?limit=${limit}&page=${page}&search=${search || ''}`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}



export async function AuctionListLimit(search,start) {

  const response = await api
    .get(
      `${Api.request.URL}/auction?s=${
        search === undefined ? "" : search
      }&start=${start === undefined ? 0 : start}&limit=1000`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}


export async function printLot(lots,id) {

  var Lotnumbers = lots.replace(/\n/g, ',');

  const response = await api 
    .get(
      `${Api.request.URL}/report/find?lot_number=${Lotnumbers}&auction_id=${id}`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}



export async function getInvoiceNO(Email,eventId,customerName) {

  var dadada = {
    "auction_id":eventId,
    "email":Email,
    "name":customerName
} 
  const response = await api
    .post(
      `${Api.request.URL}/invoice/invoice_number`,dadada
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}


export async function findInvoice(id) {

  const response = await api
    .get(
      `${Api.request.URL}/invoice/find/${id}`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });

  return response;
}






export async function findLot(lots,id) {

  var LotNumber = lots.replace(/\n/g, ",");
  const response = await api
    .get(
      `${Api.request.URL}/report/find?lot_number=${LotNumber}&auction_id=${id}`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}


export const AuctionType = [
  {
    id: 1,
    value: "LIVE_AUCTION",
    name: "Live Auction",
  },
  {
    id: 2,
    value: "ONLINE_AUCTION",
    name: "Online Auction",
  },
  {
    id: 3,
    value: "TIME_AUCTION",
    name: "TIme Auction",
  },
  {
    id: 4,
    value: "SPCIAL_AUCTION",
    name: "Special Auction",
  },
  {
    id: 5,
    value: "EXHIBITION",
    name: "Exhibition",
  },
];

// export async function createNewArena(ArrayData) {
//   const response = await api
//     .post(`${Api.request.URL}/api/v2/Arena`, ArrayData)
//     .then((res) => {
//       return res.data.message;
//     })
//     .catch((error) => {
//       return error.response.data.message;
//     });
//   return response;
// }
